module.exports = __webpack_public_path__ + "static/media/logo.6dbba458.svg";